"use client"; // This marks this file as a client component

import React, { useEffect } from 'react';
import { useUser } from '@clerk/nextjs'; // Import useUser from Clerk
import { useRouter } from 'next/navigation'; // Import useRouter for navigation

const GamePage = () => {
    const { isSignedIn } = useUser(); // Check if the user is signed in
    const router = useRouter(); // Create a router instance

    // Check authentication status and redirect if not signed in
    useEffect(() => {
        if (!isSignedIn) {
            router.push('/sign-in'); // Redirect to sign-in page if not signed in
        }
    }, [isSignedIn, router]);

    // Game variables
    let money = 0;
    let fuel = 1000; 
    let questions = [];
    let currentQuestionIndex = 0;
    let boatPosition = { x: 0, y: 0 };
    let level = 1; 
    let controlsMuddled = false; 
    let speedBoostActive = false; 
    let immunityActive = false; 
    let fuelFreeActive = false;
    let isAime = false; // Track whether the boat is currently the AIME character
    let currentLevel = 1;
    let landAreas = []; // This will hold the land areas for the current level

    // Function to start the game
    const startGame = () => {
        console.log("Game has started!");

        // Create an initial game setup
        const gameContainer = document.getElementById('gameContainer');
        if (gameContainer) {
            // Example Boat Element
            const boatElement = document.createElement('div');
            boatElement.className = 'boat';
            boatElement.style.position = 'absolute';
            boatElement.style.top = '100px'; // Initial position
            boatElement.style.left = '100px'; // Initial position
            gameContainer.appendChild(boatElement); // Append to game container

            // Additional game logic initialization can go here...

            function muddleControls() {
                document.getElementById('status').innerText = "There seems to be some magnetic interference here...";
                const originalMovement = { up: 'ArrowUp', down: 'ArrowDown', left: 'ArrowLeft', right: 'ArrowRight' };
                const originalMoveBoat = moveBoat;
                let isMuddled = true;
                document.addEventListener('keydown', function muddleControl(event) {
                    if (isMuddled) {
                        const muddledKeys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'];
                        const randomDirection = muddledKeys[Math.floor(Math.random() * muddledKeys.length)];
                        moveBoat(randomDirection.replace("Arrow", "").toLowerCase());
                    }
                });
                setTimeout(() => {
                    isMuddled = false; 
                    document.getElementById('status').innerText = "Controls back to normal.";
                }, 5000); 
            }
    
            function resetBoatPosition() {
                const boatElement = document.getElementById('boat');
                if (currentLevel === 1) {
                    boatPosition.x = 40; // Starting position x: 0
                    boatPosition.y = 40; // Starting position y: 0
                } else if (currentLevel === 2) {
                    boatPosition.x = 0;   // Left side of the container
                    boatPosition.y = 470; // Assuming 500px height - 30px boat height
                } else if (currentLevel === 3) {
                    boatPosition.x = 400;   // Left side of the container
                    boatPosition.y = 25;   // Top of the container
                } else if (currentLevel === 4) {
                    boatPosition.x = 0;   // Left side of the container
                    boatPosition.y = 0;   // Top of the container
                } 
                boatElement.style.left = boatPosition.x + 'px';
                boatElement.style.top = boatPosition.y + 'px';
            }
    
            function levelOne() {
                currentLevel = 1; // set current level to level 1
                const boatElement = document.getElementById('boat'); // Ensure this is correctly defined here
                boatElement.style.backgroundImage = "url('boat.png')"; // Reset to boat image
                isAime = false; // Reset AIME state
                updateLandAreas(); // Update land areas for level 4
    
                // Position the pirate
                const pirate = document.createElement('div');
                pirate.classList.add('pirate');
                pirate.style.left = '200px'; // Update to desired position
                pirate.style.top = '220px'; // Update to desired position
                document.getElementById('gameContainer').appendChild(pirate); // Add to game container
                document.getElementById('gameContainer').style.backgroundImage = "url(boatback.jpg)"; 
    
                // Reset boat position to top left corner
                boatPosition = { x: 40, y: 40 }; // Set position top right
                boatElement.style.left = boatPosition.x + 'px';
                boatElement.style.top = boatPosition.y + 'px';
    
                // Move the blue square to a new location for level 4
                const blueSquare = document.querySelector('.blue-square');
                blueSquare.style.left = '300px'; // Set new horizontal position
                blueSquare.style.top = '400px'; // Set new vertical position
    
                // Position the checkpoint at a new location for level 1
                const checkpoint = document.getElementById('checkpoint');
                checkpoint.style.left = '450px'; // Adjust as necessary
                checkpoint.style.top = '0px'; // Adjust as necessary
                document.getElementById('status').innerText = "Welcome to Level 1!";
                clearObstacles();
                addNewWhirlpools();
            }
    
            function levelTwo() {
                currentLevel = 2; // Change to level 2
                const boatElement = document.getElementById('boat');
                boatElement.style.backgroundImage = "url('boat.png')"; // Reset to boat image when changing levels
                isAime = false; // Reset AIME state
                updateLandAreas(); // Update land areas for level 2
                document.getElementById('gameContainer').style.backgroundImage = "url(level2.jpg)"; // Change to new background
    
                                // Move the blue square to a new location for level 3
                                const blueSquare = document.querySelector('.blue-square');
                blueSquare.style.left = '420px'; // Set new horizontal position
                blueSquare.style.top = '380px'; // Set new vertical position
            
                // Reset boat position to bottom left corner
                boatPosition = { x: 0, y: 470 }; // Set position near the bottom left
                boatElement.style.left = boatPosition.x + 'px';
                boatElement.style.top = boatPosition.y + 'px';
    
                // Position the checkpoint mid-left
                const checkpoint = document.getElementById('checkpoint');
                checkpoint.style.left = '100px'; 
                checkpoint.style.top = '225px'; // Vertically center
                document.getElementById('status').innerText = "Welcome to Level 2!";
                clearObstacles(); 
                addNewWhirlpools(); 
            }
    
            function levelThree() {
                currentLevel = 3; // Change to level 3
                const boatElement = document.getElementById('boat'); // Ensure this is correctly defined here
                boatElement.style.backgroundImage = "url('boat.png')"; // Reset to boat image
                isAime = false; // Reset AIME state
                updateLandAreas(); // Update land areas for level 3
                document.getElementById('gameContainer').style.backgroundImage = "url(level3.jpg)"; 
    
                    // Move the blue square to a new location for level 3
                const blueSquare = document.querySelector('.blue-square');
                blueSquare.style.left = '270px'; // Set new horizontal position
                blueSquare.style.top = '200px'; // Set new vertical position
    
                 // Reset boat position to top right corner
                 boatPosition = { x: 400, y: 25  }; // Set position near the bottom left
                boatElement.style.left = boatPosition.x + 'px';
                boatElement.style.top = boatPosition.y + 'px';
    
                // Position the checkpoint at a new location for level 3
                const checkpoint = document.getElementById('checkpoint');
                checkpoint.style.left = '270px'; // Adjust as necessary
                checkpoint.style.top = '300px'; // Adjust as necessary
                document.getElementById('status').innerText = "Welcome to Level 3!";
                clearObstacles(); 
                addNewWhirlpools(); 
            }
                
            function levelFour() {
                currentLevel = 4; // Change to level 4
                const boatElement = document.getElementById('boat'); // Ensure this is correctly defined here
                boatElement.style.backgroundImage = "url('boat.png')"; // Reset to boat image
                isAime = false; // Reset AIME state
                updateLandAreas(); // Update land areas for level 4
    
                // Position the pirate
                const pirate = document.createElement('div');
                pirate.classList.add('pirate');
                pirate.style.left = '250px'; // Update to desired position
                pirate.style.top = '250px'; // Update to desired position
                document.getElementById('gameContainer').appendChild(pirate); // Add to game container
                document.getElementById('gameContainer').style.backgroundImage = "url(level4.jpg)"; 
    
                // Reset boat position to top right corner
                boatPosition = { x: 430, y: 0 }; // Set position top right
                boatElement.style.left = boatPosition.x + 'px';
                boatElement.style.top = boatPosition.y + 'px';
    
                // Move the blue square to a new location for level 4
                const blueSquare = document.querySelector('.blue-square');
                blueSquare.style.left = '270px'; // Set new horizontal position
                blueSquare.style.top = '200px'; // Set new vertical position
    
                // Position the checkpoint at a new location for level 4
                const checkpoint = document.getElementById('checkpoint');
                checkpoint.style.left = '0px'; // Adjust as necessary
                checkpoint.style.top = '140px'; // Adjust as necessary
                document.getElementById('status').innerText = "Welcome to Level 4!";
                clearObstacles();
                addNewWhirlpools();
            }
    
            function purchasePowerUp(cost) {
                if (money >= cost) {
                    money -= cost;
                    if (cost === 100) {
                        speedBoostActive = true;
                        setTimeout(() => {
                            speedBoostActive = false; 
                            document.getElementById('status').innerText = "Speed boost has expired.";
                        }, 10000); 
                    }
                    document.getElementById('money').innerText = money;
                    document.getElementById('status').innerText = "Purchased power-up!";
                } else {
                    document.getElementById('status').innerText = "Not enough money!";
                }
            }
    
            // Initialize game by setting up level 1 land areas
            updateLandAreas(); // Call this initially
    
      
    
            // Ensure boat stays in bounds, check against walls of the container (500x500)
            function keepBoatInBounds() {
                if (boatPosition.x < 0) boatPosition.x = 0;
                if (boatPosition.x > 470) boatPosition.x = 470; // 500 - boat width
                if (boatPosition.y < 0) boatPosition.y = 0;
                if (boatPosition.y > 470) boatPosition.y = 470; // 500 - boat height
            }
    
            // Check for collision with blue square
            function checkForBlueSquare(boatRect) {
                const blueSquare = document.querySelector('.blue-square');
                const blueSquareRect = blueSquare.getBoundingClientRect();
                return (
                    boatRect.right > blueSquareRect.left &&
                    boatRect.left < blueSquareRect.right &&
                    boatRect.bottom > blueSquareRect.top &&
                    boatRect.top < blueSquareRect.bottom
                );
            }
    
            function drawAimeArea() {
                const canvas = document.getElementById('landCanvas');
                const ctx = canvas.getContext('2d');
            
            }
            
            drawAimeArea(); // Draw the AIME area
        }
    };

    return (
        <div>
            {isSignedIn ? (
                <>
                    <h1>Sail the Boat Game!</h1>
                    <div id="gameContainer" style={{ position: 'relative', margin: 'auto', border: '2px solid #00796b', width: '500px', height: '500px', background: 'url(boatback.jpg) no-repeat center', backgroundSize: 'cover', overflow: 'hidden' }}>
                        <canvas id="landCanvas" width="500" height="500"></canvas>
                        <div id="boat" className="boat" style={{ top: '0', left: '0' }}></div>
                        <div className="whirlpool" style={{ top: '100px', left: '100px' }}></div>
                        <div className="whirlpool" style={{ top: '150px', left: '300px' }}></div>
                        <div className="muddle" style={{ top: '200px', left: '50px' }}></div>
                        <div className="muddle" style={{ top: '250px', left: '350px' }}></div>
                        <div className="muddle" style={{ top: '350px', left: '100px' }}></div>
                        <div className="muddle" style={{ top: '100px', left: '400px' }}></div>
                        <div className="treasure" style={{ top: '50px', left: '400px' }}></div>
                        <div className="treasure" style={{ top: '300px', left: '100px' }}></div>
                        <div className="treasure" style={{ top: '350px', left: '350px' }}></div>
                        <div className="treasure" style={{ top: '150px', left: '250px' }}></div>
                        <div className="treasure" style={{ top: '450px', left: '200px' }}></div>
                        <div className="blue-square" style={{ position: 'absolute', width: '75px', height: '75px', background: 'url(port.png) no-repeat center', backgroundSize: 'contain', left: '310px', top: '340px' }}></div>
                        <div className="checkpoint" id="checkpoint" style={{ bottom: '0', right: '0' }}></div>
                    </div>
                </>
            ) : (
                <div>Loading...</div> // Show loading while checking auth status
            )}
        </div>
    );
};

export default GamePage;